import { httpClient, rawAuthTransformRequest } from '@/services/api';

type TEmailHashResponse = {
	Retorno: string;
};

/**
 * Subconjunto do perfil do anunciante (endpoint `acesso/dados-usuario`)
 * consumido pelo bloco `user` do objDataLayer. A garagem lê exatamente esses
 * campos do store Redux para montar o dataLayer (`hoc/withAdobeLaunch`) —
 * replicamos aqui para manter a estrutura de analytics idêntica.
 */
type TAdvertiserProfile = {
	Id: number;
	Sexo: string;
	DataNascimento: string;
	Cidade: string;
	Uf: string;
};

type TUserDataResponse = {
	Retorno: TAdvertiserProfile | null;
};

const advertiserService = {
	getEmailHash: async (email: string): Promise<string> => {
		const { data } = await httpClient.get<TEmailHashResponse>(
			'pf/v1/anunciante/Email-Hash',
			{ params: { email }, transformRequest: rawAuthTransformRequest }
		);
		return data.Retorno;
	},

	/**
	 * Retorna o perfil do anunciante autenticado. Espelha o `getAdvertiser` da
	 * garagem (`POST v1/acesso/dados-usuario` com `{ hash: '' }`). Usa
	 * `rawAuthTransformRequest` porque o gateway `pf/acesso` valida o `idToken`
	 * CRU — o prefixo `Bearer` (exigido só pela API `ad/v1`) causa 401 aqui.
	 */
	getUserData: async (): Promise<TAdvertiserProfile | null> => {
		const { data } = await httpClient.post<TUserDataResponse>(
			'pf/v1/acesso/dados-usuario',
			{ hash: '' },
			{ transformRequest: rawAuthTransformRequest }
		);
		return data.Retorno ?? null;
	}
};

export { advertiserService };
export type { TAdvertiserProfile };
